import { useLingui } from '@lingui/react/macro';
import { cn } from '@worldcoo/ui/lib/utils';
import { InfoIcon } from 'lucide-react';

export function NotTranslatedInfo(props: { className?: string }) {
	const { t } = useLingui();
	return (
		<p
			className={cn('bg-primary text-primary-foreground flex w-fit items-center gap-2 rounded-xl p-3', props.className)}
		>
			<InfoIcon className="size-5" />
			<span className="text-sm font-light -tracking-[0.2px]">{t`This project is not yet available in your language.`}</span>
		</p>
	);
}
